import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { NgFor, NgIf, CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import FileSaver from 'file-saver';
import { Subscription } from 'rxjs';
import { OtherProductService } from '../../../../Services/OtherProduct/other-product.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { HttpParams } from '@angular/common/http';
import { StockService } from '../../../../Services/Stock/stock.service';
import { RetailStockComponent } from '../../report/retail-stock/retail-stock.component';

@Component({
  selector: 'app-non-jewellery-product-list',
  standalone: true,
  imports: [NgFor, NgIf, RouterLink, FormsModule, CommonModule,RetailStockComponent],
  templateUrl: './non-jewellery-product-list.component.html',
  styleUrl: './non-jewellery-product-list.component.css'
})
export class NonJewelleryProductListComponent implements OnInit, OnDestroy {
  paginatedStockList: any[] = [];
  productList: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;
  startDate: string = '';
endDate: string = '';
filteredProductList: any[] = [];

  searchValues: { [key: string]: string } = {};
  sortKey: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  showDropdown: boolean = false;
  globalSearchText: string = '';
  isRetailModalOpen = false;
  selectedStockItem: any = null;

  defaultFields = [
    { key: 'st_item_code', label: 'Product Code', selected: true },
    { key: 'st_item_name', label: 'Product Name', selected: true },
    { key: 'category_name', label: 'Product Category', selected: true },
    { key: 'st_distribution', label: 'Stock Type', selected: true },
    { key: 'st_metal_rate', label: 'Cost Per Product', selected: true },
    { key: 'st_sell_rate', label: 'Selling Price / MRP', selected: true },
    { key: 'st_quantity', label: 'Quantity in Stock', selected: true },
    { key: 'created_at', label: 'Created At', selected: false },
  ];

  selectedFields: any[] = []; 
  firmSubscription!: Subscription;
  router = inject(Router);

  constructor(
    private otherProductService: OtherProductService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService,
    private stockService:StockService
  ) {}

  ngOnInit(): void {
    this.loadSelectedFields();
    this.firmSubscription = this.firmSelectionService.selectedFirmName$.subscribe((firm) => {
      if (firm && firm.id) {
        // this.getProducts();
        this.getStockList();
      } else {
        this.productList = [];
        this.paginatedStockList = [];
      }
    });
  }

  loadSelectedFields() {
    const saved = localStorage.getItem('nonJewellerySelectedFields');
    if (saved) {
      const storedFields = JSON.parse(saved);
      const storedMap = new Map(storedFields.map((f: any) => [f.key, f.selected]));
      this.selectedFields = this.defaultFields.map(df => ({
        ...df,
        selected: storedMap.has(df.key) ? storedMap.get(df.key) : df.selected
      }));
    } else {
      this.selectedFields = [...this.defaultFields];
    }
  }


  openRetailModal(item: any) {
    this.selectedStockItem = item;
    this.isRetailModalOpen = true;
  }

  closeRetailModal() {
    this.isRetailModalOpen = false;
    this.selectedStockItem = null;
  }


  saveSelectedFields() {
    localStorage.setItem('nonJewellerySelectedFields', JSON.stringify(this.selectedFields));
  }

  // getProducts() {
  //   this.otherProductService.getOtherProducts().subscribe({
  //     next: (res: any) => {
  //       if (res.success) {
  //         this.productList = res.data.reverse();
  //         this.filterTable();
  //       }
  //     },
  //     error: () => this.notificationService.showError('Failed to fetch products', 'Error')
  //   });
  // }

  getStockList() {
    let params = new HttpParams().set('stock_type','Product');
    this.stockService.getStockEntriesWithParams(params).subscribe(
      (response: any) => {
        console.log('Stock List Response:', response);
        if (response?.data?.length) {
          this.productList = response.data.reverse().map((item: any) => ({
          ...item,
          category_name: item.st_item_category?.name
        }));
          this.filterTable(); // Apply filters and pagination after fetching data
        } else {
          this.productList = [];
          this.paginatedStockList = [];
          this.totalPages = 0;
        }
      },
      (error: any) => {
        this.notificationService.showError(
          'Failed to fetch stock entries.',
          'Error'
        );
        this.productList = [];
        this.paginatedStockList = [];
        this.totalPages = 0;
      }
    );
  }

 filterTable() {

  console.log('================ FILTER START ================');
  console.log('START DATE:', this.startDate);
  console.log('END DATE:', this.endDate);

  let filtered = [...this.productList];

  /* ================= DATE FILTER ================= */

  if (this.startDate || this.endDate) {

    filtered = filtered.filter(item => {

      const itemDateRaw = item['created_at'];

      console.log('RAW created_at:', itemDateRaw);

      if (!itemDateRaw) {
        console.warn('❌ No created_at found');
        return false;
      }

      // Safe split (NO timezone issue)
      const itemDate = itemDateRaw.split(' ')[0];

      console.log('NORMALIZED DATE:', itemDate);

      if (this.startDate && itemDate < this.startDate) {
        console.log('❌ Before start date');
        return false;
      }

      if (this.endDate && itemDate > this.endDate) {
        console.log('❌ After end date');
        return false;
      }

      console.log('✅ Date Passed');
      return true;
    });
  }

  /* ================= COLUMN FILTER ================= */

  filtered = filtered.filter((item: any) => {

    const matchesFieldFilters = this.selectedFields.every((field) => {
      if (!field.selected) return true;

      const searchTerm = (this.searchValues[field.key] || '')
        .trim()
        .toLowerCase();

      if (!searchTerm) return true;

      return (item[field.key] ?? '')
        .toString()
        .toLowerCase()
        .includes(searchTerm);
    });

    const matchesGlobalSearch = this.globalSearchText
      ? Object.values(item).some((val) =>
          (val ?? '')
            .toString()
            .toLowerCase()
            .includes(this.globalSearchText.trim().toLowerCase())
        )
      : true;

    return matchesFieldFilters && matchesGlobalSearch;
  });

  /* ================= SORT ================= */

  if (this.sortKey) {
    filtered.sort((a, b) => {
      const valA = a[this.sortKey] ?? '';
      const valB = b[this.sortKey] ?? '';

      return this.sortDirection === 'asc'
        ? valA > valB ? 1 : -1
        : valA < valB ? 1 : -1;
    });
  }

  console.log('TOTAL BEFORE PAGINATION:', filtered.length);
  console.log('================ FILTER END ================');

  /* ================= PAGINATION ================= */
  this.filteredProductList = filtered;

  this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);

  const start = (this.currentPage - 1) * this.itemsPerPage;

  this.paginatedStockList = filtered.slice(
    start,
    start + this.itemsPerPage
  );
}


  // EXPORT LOGIC (EXACT COPIED FROM YOUR REFERENCE)
  downloadPDF(): void {
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
    const selectedFields = this.selectedFields.filter(f => f.selected);
    if (!selectedFields.length) return;

    const pageWidth = doc.internal.pageSize.getWidth();
    doc.setFont('helvetica', 'bold');
    doc.text('Other Product Report', pageWidth / 2, 16, { align: 'center' });

    const headers = [{ header: 'No.', dataKey: 'no' }, ...selectedFields.map(f => ({ header: f.label, dataKey: f.key }))];
    const sourceData = this.getExportSourceData();

const body = sourceData.map((item, index) => {
  const row: any = { no: index + 1 };
  selectedFields.forEach(f => row[f.key] = this.getDisplayValue(item[f.key]));
  return row;
});


    autoTable(doc, {
      columns: headers,
      body,
      startY: 24,
      theme: 'grid',
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [193, 151, 37], textColor: 255, halign: 'center' }
    });
    doc.save('Other_Product_Report.pdf');
  }

  downloadExcel(): void {

  const selectedFields = this.selectedFields.filter(f => f.selected);

  // ✅ Correct numeric backend keys
  const numericKeys = [
    'st_metal_rate',
    'st_sell_rate',
    'st_quantity'
  ];

 const sourceData = this.getExportSourceData();

const data = sourceData.map((item, index) => {


    const row: any = { 'No.': index + 1 };

    selectedFields.forEach((field) => {

      let value: any = item[field.key];

      // ✅ Force numeric conversion
      if (numericKeys.includes(field.key)) {
        value =
          value !== null &&
          value !== undefined &&
          value !== ''
            ? Number(value)
            : 0;
      }

      row[field.label] = value ?? '';
    });

    return row;
  });

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

  // ✅ Force numeric cell type for Excel
  Object.keys(worksheet).forEach((cell) => {
    if (cell.startsWith('!')) return;

    const c = worksheet[cell];
    if (typeof c.v === 'number') {
      c.t = 'n';
    }
  });

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Product List': worksheet },
    SheetNames: ['Product List']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  FileSaver.saveAs(
    new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }),
    'Other_Product_List.xlsx'
  );
}

  downloadJSONAll(): void {
    const jsonString = JSON.stringify(this.getExportSourceData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    FileSaver.saveAs(blob, 'Other_Product_List.json');
  }

  downloadCSV(): void {
    const selectedFields = this.selectedFields.filter(f => f.selected);
    const headers = ['No.', ...selectedFields.map(f => f.label)];
    let csvContent = headers.join(',') + '\n';

    this.getExportSourceData().forEach((item, index) => {
      const row = [index + 1, ...selectedFields.map(f => {
        const val = this.getDisplayValue(item[f.key]);
        return val.includes(',') ? `"${val}"` : val;
      })];
      csvContent += row.join(',') + '\n';
    });
    FileSaver.saveAs(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }), 'Other_Product_List.csv');
  }

  printTable() {
    let printContent = `<html><head><style>table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid black; padding: 8px; text-align: left; font-size: 12px; } thead { background: #f2f2f2; }</style></head><body><h3>Other Product List</h3><table><thead><tr><th>No.</th>`;
    this.selectedFields.forEach(f => { if (f.selected) printContent += `<th>${f.label}</th>`; });
    printContent += `</tr></thead><tbody>`;
    this.getExportSourceData().forEach((item, index) => {
      printContent += `<tr><td>${index + 1}</td>`;
      this.selectedFields.forEach(f => { if (f.selected) printContent += `<td>${this.getDisplayValue(item[f.key])}</td>`; });
      printContent += `</tr>`;
    });
    printContent += `</tbody></table></body></html>`;
    const win = window.open('', '_blank');
    win?.document.write(printContent);
    win?.document.close();
    win?.print();
  }

  // --- Helpers ---
  deleteProduct(id: any) {
    if (confirm('Delete product?')) {
      this.stockService.deleteStockEntry(id).subscribe(() => {
        this.notificationService.showSuccess('Deleted', 'Success');
        // this.getProducts();
        this.getStockList();
      });
    }
  }

  getDisplayValue(value: any): string {
    if (value === null || value === undefined) return "";
    return String(value);
  }

  sortBy(key: string) {
    this.sortDirection = this.sortKey === key && this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortKey = key;
    this.filterTable();
  }

  goToPage(p: number) { this.currentPage = p; this.filterTable(); }
  get pageNumbers() { return Array.from({ length: this.totalPages }, (_, i) => i + 1); }
  toggleDropdown() { this.showDropdown = !this.showDropdown; }
  selectAllFields() { this.selectedFields.forEach(f => f.selected = true); this.saveSelectedFields(); this.filterTable(); }
  deselectAllFields() { this.selectedFields.forEach(f => f.selected = false); this.saveSelectedFields(); this.filterTable(); }
  restoreColumnSelection() { localStorage.removeItem('nonJewellerySelectedFields'); this.loadSelectedFields(); this.filterTable(); }

  ngOnDestroy() { if (this.firmSubscription) this.firmSubscription.unsubscribe(); }

  get totalCostValue(): number {
    const groups: { [code: string]: { cost: number; totalQty: number } } = {};
    this.productList.forEach((item: any) => {
      const code = item.st_item_code;
      const qty = parseFloat(item.st_quantity) || 0;
      const cost = parseFloat(item.st_metal_rate) || 0;
      if (!groups[code]) { groups[code] = { cost: 0, totalQty: 0 }; }
      groups[code].totalQty += qty;
      if (cost > 0) { groups[code].cost = cost; }
    });
    return Object.values(groups).reduce((sum, g) => sum + (g.cost * g.totalQty), 0);
  }

  get totalSellingValue(): number {
    const groups: { [code: string]: { sell: number; totalQty: number } } = {};
    this.productList.forEach((item: any) => {
      const code = item.st_item_code;
      const qty = parseFloat(item.st_quantity) || 0;
      const sell = parseFloat(item.st_sell_rate) || 0;
      if (!groups[code]) { groups[code] = { sell: 0, totalQty: 0 }; }
      groups[code].totalQty += qty;
      if (sell > 0) { groups[code].sell = sell; }
    });
    return Object.values(groups).reduce((sum, g) => sum + (g.sell * g.totalQty), 0);
  }

  private getExportSourceData(): any[] {

  const hasFilter =
    this.startDate ||
    this.endDate ||
    this.globalSearchText ||
    Object.values(this.searchValues).some(v => v);

  return hasFilter
    ? this.filteredProductList   // filtered data
    : this.productList;          // full data
}

}